
import React, { Component } from "react";
import "./rule.scss";
var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
export default class shipments extends React.Component {
   
    render() {
        document.title = '说明';
        return ( 
            <div className = { isiOS ? 'IOSBulletprivacyHome BulletprivacyHome' : 'BulletprivacyHome' } >
                <div className = "Bulletprivacy earnestMoney futures shipments" >
                    <h2 > 商城说明 </h2>
                    1.商城交易的是<span className="fontboldWet">平台审核指定的评级/封装标准化商品</span>，非平台审核通过的品种不可以发布到商城。<br/>
                    2.商城交易规则与现货成交48小时发货规则一致。<br/>
                    3.如有品种需要投放商城，请联系管理员。<br/>
                </div>  
            </div>
        );
    }
}